import API from "@/api";

export const moduleName = "taxCredit";

export const actionTypes = {
  ACTION_LOAD_TAXCREDIT: "ACTION_LOAD_TAXCREDIT",
};

export const getterTypes = {
  GETTER_TAXCREDIT: "GETTER_TAXCREDIT",
  GETTER_TAXCREDIT_COUNT: 'GETTER_TAXCREDIT_COUNT',
  GETTER_CHECKED_ROWS: 'GETTER_CHECKED_ROWS',
};

export const mutationTypes = {
  SET_TAXCREDIT_DATA: "SET_TAXCREDIT_DATA",
  SET_CHECKED_ROW: 'SET_CHECKED_ROW',
  SET_CHECKED_ROWS: 'SET_CHECKED_ROWS',
  UNSET_CHECKED_ROWS: 'UNSET_CHECKED_ROWS',
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    checkedDealerTableRows: [],
    taxCredits: [],
    taxCreditsCount: 0
  }),

  actions: {
    async [actionTypes.ACTION_LOAD_TAXCREDIT]({ commit }, payload) {
      const response = await API.taxCreditManager.loadTaxCredits(payload);
      const { taxCredits, taxCreditsCount } = response.data;
      commit(mutationTypes.SET_TAXCREDIT_DATA, [taxCredits, taxCreditsCount]);
    },
  },

  mutations: {
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedUserManagerTableRows = []
    },
    [mutationTypes.SET_TAXCREDIT_DATA](state, [taxCredits, taxCreditsCount]) {
      if (Array.isArray(taxCredits)) {
        state.taxCredits = taxCredits;
      }
      if (!isNaN(taxCreditsCount)) {
        state.taxCreditsCount = taxCreditsCount;
      }
    },
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedDealerTableRows = []
    },
    [mutationTypes.SET_CHECKED_ROW] (state, row) {
      const targetIndex = state.checkedDealerTableRows.indexOf(row)
      if (targetIndex >= 0) {
        state.checkedDealerTableRows.splice(targetIndex, 1)
      } else {
        state.checkedDealerTableRows.push(row)
      }
    },

    [mutationTypes.SET_CHECKED_ROWS] (state, rows) {
      if (state.checkedDealerTableRows.length > 0 && state.checkedDealerTableRows.every(row => rows.includes(row))) {
        state.checkedDealerTableRows = []
      } else {
        state.checkedDealerTableRows = [...rows]
      }
    },
  },

  getters: {
    [getterTypes.GETTER_TAXCREDIT]: state => state.taxCredits,
    [getterTypes.GETTER_TAXCREDIT_COUNT]: (state) => state.taxCreditsCount,
    [getterTypes.GETTER_CHECKED_ROWS]: (state) => state.checkedDealerTableRows,
  }
};
